




































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { SysKBContentListModule } from '@/store/modules/sysKBContentList';
import KBSearchResultDto from '@/models/KnowledgeBase/KBSearchResultDto';
import KBContentSearchResult from '@/models/KnowledgeBase/KBContentSearchResult';

@Component({
  name: 'KBSearchResults'
})
export default class KBSearchResults extends Vue {
  @Prop({ required: true })
  public query!: string;

  private loadingMore = false;

  get loading(): boolean {
    return SysKBContentListModule.loadingSearch;
  }

  get results(): KBSearchResultDto | null {
    return SysKBContentListModule.searchResults;
  }

  selectArticle(item: KBContentSearchResult) {
    this.$emit('article-selected', item.slug);
  }

  async loadMore() {
    this.loadingMore = true;
    try {
      const currentLimit = this.results?.limit || 20;
      await SysKBContentListModule.search({
        query: this.query,
        semantic: true,
        limit: currentLimit + 20
      });
    } finally {
      this.loadingMore = false;
    }
  }

  formatDate(date: Date): string {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
}
